export default __webpack_public_path__ + "static/media/22.d3b2f7bd.jpg";